/* eslint-disable @typescript-eslint/require-await */

/**
 * Live Transcription service
 * @module LiveTranscription
 */

import { Service } from 'rainbow-web-sdk/services/service';
import { AuthService, LoggerService, SettingsService, XmppService } from '../core';
import { DataChannelService } from '../dataChannel';
import { DataChannelService_RB } from '../dataChannel/dataChannel.service';
import { Subject, Subscription, filter } from 'rxjs';
import { Bubble, LiveTranscription, RBEvent } from 'rainbow-web-sdk/models';
import { PromiseQueue } from 'rainbow-web-sdk/utils/promiseQueue';
import { LiveTranscriptionRB } from '../../models/transcription.model';
import xmlParser from '../../utils/xmlParser';
import { ErrorHelperService } from '../utilities';
import { BubbleConferenceServiceRB } from '../conference/bubbleConference.service';

/** @internal */
export const LIVE_TRANSCRIPTION_SVC = 'LiveTranscriptionService';

/**
 * TranscriptionService events list
 * @eventProperty
 */
export enum LiveTranscriptionServiceEvents {
    /**
     * @eventProperty
     * This RBEvent is send when a liveTranscription + Data Channel is available (but not yet active)
     */
    ON_LIVE_TRANSCRIPTION_CHANNEL_AVAILABLE = 'ON_LIVE_TRANSCRIPTION_CHANNEL_AVAILABLE',
    /**
     * @eventProperty
     * This RBEvent is send when a liveTranscription is available
     */
    ON_LIVE_TRANSCRIPTION_AVAILABLE = 'ON_LIVE_TRANSCRIPTION_AVAILABLE',

    /**
     * @eventProperty
     * This RBEvent is send when a liveTranscription is stopped
     */
    ON_LIVE_TRANSCRIPTION_STOPPED = 'ON_LIVE_TRANSCRIPTION_STOPPED'
}

export interface LiveTranscriptionService {
    /**
     * Subscribe to transcription service events
     * @param handler - The handler function that will be called on events
     * @param eventNames - The events to subscribe to
     */
    subscribe(handler: (event: RBEvent<LiveTranscriptionServiceEvents>) => any, eventNames?: LiveTranscriptionServiceEvents | LiveTranscriptionServiceEvents[]): Subscription;

    /**
     * Returns existing live transcription for a conversation
     * @param source - the sourse
     */
    getLiveTranscriptions(source: Bubble): LiveTranscription[];

    /**
     * This methods start speechToText transcription portal
     * @param source - the conversation bubble
     * @param language - the output language to be translated
     */
    startTranscription(source: Bubble, language?: string): Promise<void>;

    /**
     * This methods stop speechToText transcription portal
     * @param source - the conversation bubble
     */
    stopTranscription(source: Bubble): Promise<void>;

    /**
     * This methods send a message on transcription datachannel (DEBUG)
     * @param source - the conversation bubble
     * @param message - the message to send via transcription message
     * @internal
     */
    sendTranscriptionMessage(source: Bubble, message: string): Promise<void>;
}

/**
 * @internal
 */
export class LiveTranscriptionServiceRB extends Service implements LiveTranscriptionService {

    private logger: LoggerService = LoggerService.getInstance();
    private dataChannelService: DataChannelService = DataChannelService_RB.getInstance();
    private authService: AuthService = AuthService.getInstance();
    private settingsService: SettingsService = SettingsService.getInstance();
    private errorHelperService: ErrorHelperService = ErrorHelperService.getInstance();
    private xmppService: XmppService = XmppService.getInstance();
    private bubbleConferenceService: BubbleConferenceServiceRB = BubbleConferenceServiceRB.getInstance();
    private subscriptions: Subscription[] = [];
    private eventsSubject: Subject<RBEvent<LiveTranscriptionServiceEvents>> = new Subject<RBEvent<LiveTranscriptionServiceEvents>>();
    private transcriptions: Record<string, LiveTranscriptionRB> = {};
    private conferenceEventListener: any;
    private promiseQueue: PromiseQueue = PromiseQueue.create();

    public static getInstance() { return Service.create(LIVE_TRANSCRIPTION_SVC, LiveTranscriptionServiceRB); }
    public static build() { return new LiveTranscriptionServiceRB(); }
    private constructor() { super(); }

    public async start(): Promise<void> {
        // if (this.settingsService.getSetting('liveTranscription') !== 'true') return;
        // try {
        //     this.logger.warn(`[LiveTranscriptionService] === STARTING`);
        //     this.attachEventListeners();
        //     this.logger.warn(`[LiveTranscriptionService] === STARTED`);
        // }
        // catch (error) {
        //     this.logger.warn(`[LiveTranscriptionService] === STARTING FAILURE === ${error}`);
        // }
    }

    public async stop(): Promise<void> {
        // if (this.settingsService.getSetting('liveTranscription') !== 'true') return;
        // try {
        //     this.logger.warn(`[LiveTranscriptionService] === STOPPING`);
        //     this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
        //     this.subscriptions = [];
        //     this.logger.warn(`[LiveTranscriptionService] === STOPPED`);
        // }
        // catch (error) {
        //     this.logger.warn(`[LiveTranscriptionService] === STOPPING FAILURE === ${error}`);
        // }
    }

    public async reconnect(): Promise<void> {
        // if (this.settingsService.getSetting('liveTranscription') !== 'true') return;
        // try {
        //     this.logger.warn(`[LiveTranscriptionService] === RECONNECTING`);
        //     this.attachEventListeners();
        //     this.logger.warn(`[LiveTranscriptionService] === RECONNECTED`);
        // }
        // catch (error) {
        //     this.logger.warn(`[LiveTranscriptionService] === RECONNECTING FAILURE === ${error}`);
        // }
    }

    private attachEventListeners(): void {
        this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
        this.subscriptions = [];
        // this.subscriptions.push(this.dataChannelService.subscribe((event: RBEvent<DataChannelServiceEvents>) => {
        //     const dataChannel: DataChannel = event.data;
        //     if (dataChannel.id !== 'liveTranscription') return;
        //     //a data channel is available to subscribe to the live transcription; So we can now choose to subscribe or not

        //     const bubbleConference = this.bubbleConferenceService.getActiveWebConferenceSession();
        //     if (!bubbleConference || dataChannel.bubble?.dbId !== bubbleConference.id) {
        //         this.logger.info(`[LiveTranscriptionService] onLiveTranscriptionAvailable for bubble: ${dataChannel.bubble?.dbId} is ignored as conference is not active`);
        //         return;
        //     }

        //     //we've an active conference related to that data channel; Update the web conference accordingly
        //     switch (event.name) {
        //         case DataChannelServiceEvents.ON_DATACHANNEL_AVAILABLE:
        //             this.logger.info(`[LiveTranscriptionService] onLiveTranscriptionAvailable(bubble: ${dataChannel.bubble.dbId}, id: ${dataChannel.id})`);
        //             const transcription = LiveTranscriptionRB.create(dataChannel);
        //             this.transcriptions[dataChannel.bubble.dbId] = transcription;
        //             // bubbleConference.liveTranscription.liveTranscriptionChannel = transcription;

        //             //check if we need to accept the data channel;
        //             // if (bubbleConference.liveTranscription.liveTranscriptionActivated) {
        //             //     this.subscribeToLiveTranscriptionDataChannel(bubbleConference);
        //             // }
        //             this.sendEvent(LiveTranscriptionServiceEvents.ON_LIVE_TRANSCRIPTION_AVAILABLE, transcription);
        //             break;
        //         case DataChannelServiceEvents.ON_DATACHANNEL_CLOSED:
        //             const closedTranscription = this.transcriptions[dataChannel.bubble.dbId];
        //             if (closedTranscription) { closedTranscription.stop(); }
        //             delete this.transcriptions[dataChannel.bubble.dbId];
        //             this.sendEvent(LiveTranscriptionServiceEvents.ON_LIVE_TRANSCRIPTION_STOPPED, closedTranscription);
        //             this.logger.info(`[LiveTranscriptionService] onLiveTranscriptionClosed(bubble: ${dataChannel.bubble.dbId}, id: ${dataChannel.id})`);
        //             break;
        //     }
        // }));

        if (this.conferenceEventListener) { this.xmppService.deleteHandler(this.conferenceEventListener); this.conferenceEventListener = undefined; }
        this.conferenceEventListener = this.xmppService.addHandler((stanza: any) => { this.promiseQueue.add(() => this.onConferenceInfo(stanza)); return true; }, 'jabber:iq:conference:2', 'message');
    }

    public subscribe(handler: (event: RBEvent<LiveTranscriptionServiceEvents>) => any, eventNames?: LiveTranscriptionServiceEvents | LiveTranscriptionServiceEvents[]): Subscription {
        const observable = eventNames
            ? this.eventsSubject.pipe(filter((event: RBEvent<LiveTranscriptionServiceEvents>) => {
                if (eventNames instanceof Array) return eventNames.indexOf(event.name) !== -1;
                return event.name === eventNames;
            }))
            : this.eventsSubject;

        return observable.subscribe((event: RBEvent<LiveTranscriptionServiceEvents>) => {
            try { handler(event); }
            catch (error) { this.logger.error(`[LiveTranscriptionService] subscribe () -- error -- ${error.message}`); }
        });
    }

    public sendEvent(name: LiveTranscriptionServiceEvents, data: any = null) {
        this.eventsSubject.next(RBEvent.create(name, data));
    }

    // private async subscribeToLiveTranscriptionDataChannel(bubbleConference: WebConferenceSession) {
    //     try {
    //         if (bubbleConference?.liveTranscription?.liveTranscriptionActivated) {
    //             await bubbleConference.liveTranscription.liveTranscriptionChannel.accept();
    //         }
    //     }
    //     catch (error) {
    //         this.logger.error(`[LiveTranscriptionService] subscribeToLiveTranscriptionDataChannel for ${bubbleConference.id} -- error -- ${error?.message}`);
    //         bubbleConference.liveTranscription.liveTranscriptionActivated = false;
    //     }
    // }

    public async startTranscription(source: Bubble, language: string = 'fr'): Promise<void> {
        try {
            const inputLanguage = this.settingsService.getSetting('liveTranscriptionInputLanguage');
            const translationLanguages = ["en", "fr", "es", "ar", "zh"].filter((item) => { return item !== inputLanguage; });
            const data = { translationLanguages };
            if (inputLanguage) { data['inputLanguages'] = [inputLanguage]; }
            this.logger.info(`[LiveTranscriptionService] startTranscription (source: ${source.dbId}) with config input: ${inputLanguage} -- output: ${language}`);
            const url = `${config.restServerUrl}/api/rainbow/conference/v1.0/rooms/${source.dbId}/start-live-transcription`;
            const body = JSON.stringify(data);
            const headers = this.authService.getPostHeader();
            const response = await fetch(url, { method: 'PUT', headers, body });
            if (!response.ok) throw response;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, "startTranscription");
            this.logger.error(`[LiveTranscriptionService] ${errorInfo.error.message}`);
            throw (errorInfo.error);
        }
    }

    public async stopTranscription(source: Bubble): Promise<void> {
        try {
            this.logger.info(`[LiveTranscriptionService] stopTranscription (source: ${source.dbId})`);
            const url = `${config.restServerUrl}/api/rainbow/conference/v1.0/rooms/${source.dbId}/stop-live-transcription`;
            const headers = this.authService.getPostHeader();
            const response = await fetch(url, { method: 'PUT', headers });
            if (!response.ok) throw response;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, "stopTranscription");
            this.logger.error(`[LiveTranscriptionService] ${errorInfo.error.message}`);
            throw (errorInfo.error);
        }
    }

    public async sendTranscriptionMessage(source: Bubble, message: string): Promise<void> {
        try {
            this.logger.info(`[LiveTranscriptionService] sendTranscriptionMessage (source: ${source.dbId})`);
            const url = `${config.restServerUrl}/api/rainbow/conference/v1.0/rooms/${source.dbId}/send-transcription-message`;
            const headers = this.authService.getPostHeader();
            const body = JSON.stringify({ text: message });
            const response = await fetch(url, { method: 'PUT', headers, body });
            if (!response.ok) throw response;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, "sendTranscriptionMessage");
            this.logger.error(`[LiveTranscriptionService] ${errorInfo.error.message}`);
            throw (errorInfo.error);
        }
    }

    public getLiveTranscriptions(source: Bubble): LiveTranscription[] {
        const nbTranscriptions = this.transcriptions ? Object.keys(this.transcriptions).length : 0;
        this.logger.info(`[LiveTranscriptionService] getLiveTranscriptions(conv: ${source.dbId}) -- ${nbTranscriptions} transcription(s) founded`);
        return nbTranscriptions > 0 ? [this.transcriptions[source.dbId]] : [];
    }

    // public async getCustomPromptsForTranscription(): Promise<{ name: string; id: string; }[]> {
    //     try {
    //         const url = `${config.restServerUrl}/api/rainbow/aihub/v1.0/enduser/prompts`;
    //         const headers = this.authService.getRequestHeader();
    //         const response = await fetch(url, { method: 'GET', headers });
    //         if (!response.ok) { throw response; }
    //         const jsonResponse = await response.json();

    //         const items: { name: string; id: string; }[] = jsonResponse.data.map((item) => {
    //             return { name: item.name, id: item.id };
    //         });
    //         return items;

    //     }
    //     catch (error) {
    //         const errorInfo = await this.errorHelperService.getErrorInfo(error, "getCustomPromptsForTranscription");
    //         this.logger.error(`[LiveTranscriptionService] ${errorInfo.error.message}`);
    //         throw (errorInfo.error);
    //     }
    // }

    private async onConferenceInfo(stanza: any): Promise<any> {
        try {
            const stanzaElem = xmlParser(stanza);
            const conferenceInfoElems = stanzaElem.find('conference-info');
            if (conferenceInfoElems.length) {
                const event = conferenceInfoElems.attr('event');
                if (event === 'stopTranscription') {
                    const bubbleId = conferenceInfoElems.find('room-id').text();
                    const closedTranscription = this.transcriptions[bubbleId];
                    if (closedTranscription) { closedTranscription.stop(); }
                    delete (this.transcriptions[bubbleId]);
                    this.sendEvent(LiveTranscriptionServiceEvents.ON_LIVE_TRANSCRIPTION_STOPPED, closedTranscription);
                    this.logger.info(`[LiveTranscriptionService] onLiveTranscriptionClosed(bubble: ${bubbleId})`);
                }
            }
        }
        catch (error) {
            this.logger.error(`[LiveTranscriptionService] onConferenceInfo -- failure -- ${error.message}`);
        }
    }

}
